
import { handleActions } from 'redux-actions';

import { TIMELINE_ACTION_TYPES } from './constants';
import TimelineState from './TimelineState';
import { PROJECT_ACTION_TYPES } from '../projects/constants';

import type { Action } from '../types';
import type {
  ReceiveTimelineEventPayload,
  ReceiveTimelineEventsPayload,
  ReceiveActiveTimelineEvent
} from './types';

const initialState = new TimelineState();

const actions = {
  [TIMELINE_ACTION_TYPES.CREATE_TIMELINE_EVENT]: createTimelineEvent,
  [TIMELINE_ACTION_TYPES.UPDATE_TIMELINE_EVENT]: updateTimelineEvent,
  [TIMELINE_ACTION_TYPES.FETCH_TIMELINE_EVENTS]: fetchTimelineEvents,
  [TIMELINE_ACTION_TYPES.FETCH_DEFAULT_TIMELINE_EVENTS]: fetchDefaultTimelineEvents,
  [TIMELINE_ACTION_TYPES.RECEIVE_TIMELINE_EVENT]: receiveTimelineEvent,
  [TIMELINE_ACTION_TYPES.RECEIVE_TIMELINE_EVENTS]: receiveTimelineEvents,
  [TIMELINE_ACTION_TYPES.RECEIVE_DEFAULT_TIMELINE_EVENTS]: receiveDefaultTimelineEvents,
  [TIMELINE_ACTION_TYPES.RECEIVE_ACTIVE_EVENT]: receiveActiveEvent,
  [TIMELINE_ACTION_TYPES.RECEIVE_UPDATED_EVENT]: receiveUpdatedTimelineEvent,

  // Project actions
  [PROJECT_ACTION_TYPES.RECEIVE_ACTIVE_PROJECT]: clearTimelineEvents
};

function clearTimelineEvents(state: TimelineState): TimelineState {
  return state.setEvents(null);
}

function fetchTimelineEvents(state: TimelineState): TimelineState {
  return state.setIsFetchingEvents(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveTimelineEvents(state: TimelineState, { payload }: Action<ReceiveTimelineEventsPayload>): TimelineState {
  if (!payload) {
    return state;
  }
  return state
    .setIsFetchingEvents(false)
    .setEvents(payload.timelineEvents);
}

function fetchDefaultTimelineEvents(state: TimelineState): TimelineState {
  return state.setIsFetchingDefaultEvents(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveDefaultTimelineEvents(state: TimelineState, { payload }: Action<ReceiveDefaultTimelineEventsPayload>): TimelineState {
  if (!payload) {
    return state;
  }
  return state
    .setIsFetchingDefaultEvents(false)
    .setDefaultEvents(payload.defaultTimelineEvents);
}


function createTimelineEvent(state: TimelineState): TimelineState {
  return state.setIsCreatingEvent(true);
}

function updateTimelineEvent(state: TimelineState): TimelineState {
  return state.setIsUpdatingEvent(true);
}

// eslint-disable-next-line object-curly-spacing
function receiveTimelineEvent(state: TimelineState, { payload }: Action<ReceiveTimelineEventPayload>): TimelineState {
  if (!payload) {
    return state;
  }
  return state
    .setIsCreatingEvent(false)
    .addOrReplaceEvent(payload.timelineEvent);
}

// eslint-disable-next-line object-curly-spacing
function receiveUpdatedTimelineEvent(state: TimelineState): TimelineState {
  return state
    .setIsUpdatingEvent(false)
}

// eslint-disable-next-line object-curly-spacing
function receiveActiveEvent(state: TimelineState, { payload }: Action<ReceiveActiveTimelineEvent>): TimelineState {
  if (!payload) {
    return state;
  }
  return state.setActiveEvent(payload.timelineEvent);
}

export default handleActions(actions, initialState);



// WEBPACK FOOTER //
// ./src/redux/timeline/reducer.js